import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

import { Store } from '@ngrx/store';

import { ListItemComponent } from '@common/extensions';
import { Entity } from '@apps/auth/domain/models/back';
import { IAuroraState } from '@apps/aurora.state';
import { BackAuthEntityUsersRequested } from '@apps/back/store/auth/entities/global/entities-global.actions';
import { BackEntityDetailsSelectSet } from '@apps/back/store/misc/misc.actions';

@Component({
    selector: 'aa-impe-entity-item',
    templateUrl: './impe-entity-item.component.html',
    styleUrls: [
        './impe-entity-item.component.scss'
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ImpeEntityItemComponent extends ListItemComponent
{
    @Input() entity: Entity;
    @Input() firstItem: boolean;
    @Input() lastItem: boolean;
    @Input() isSelected: boolean = false;

    constructor (
        private store: Store<IAuroraState>,
        routerStore: Store<any>
    )
    {
        super(routerStore, store);

    }

    rowClicked = () =>
    {
        this.store.dispatch(BackEntityDetailsSelectSet({ entity: this.entity }));
        this.store.dispatch(BackAuthEntityUsersRequested({ entityId: this.entity.id }));
    };
}
